{
  "REPORT": {
    "HEADER": "Pokalbiai",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Nepavyko gauti duomenų, bandykite dar kartą vėliau.",
    "SUMMARY_FETCHING_FAILED": "Nepavyko gauti suvestinės, bandykite dar kartą vėliau.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Viso )"
      },
      "REPLY_TIME": {
        "NAME": "Kliento laukimo laikas",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Paskutines 7 dienas",
      "LAST_14_DAYS": "Paskutines 14 dienų",
      "LAST_30_DAYS": "Paskutines 30 dienų",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Paskutinius 3 mėnesius",
      "LAST_6_MONTHS": "Paskutinius 6 mėnesius",
      "LAST_YEAR": "Paskutinius metus",
      "CUSTOM_DATE_RANGE": "Pritaikytas datos intervalas"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupuoti pagal",
    "DURATION_FILTER_LABEL": "Trukmė",
    "GROUPING_OPTIONS": {
      "DAY": "Diena",
      "WEEK": "Savaitė",
      "MONTH": "Mėnuo",
      "YEAR": "Metai"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Savaitė"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Savaitė"
      },
      {
        "id": 3,
        "groupBy": "Mėnuo"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Savaitė"
      },
      {
        "id": 3,
        "groupBy": "Mėnuo"
      }
    ],
    "BUSINESS_HOURS": "Darbo valandos",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nieko nerasta"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agentų apžvalga",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_AGENT_REPORTS": "Parsisiųsti agentų ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pasirinkti agentą",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Ieškoti agentų"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Etikečių Apžvalga",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_LABEL_REPORTS": "Parsisiųsti etiketės ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pažymėti Etiketę",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Ieškoti etikečių"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Gautų Laiškų Aplanko Apžvalga",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_INBOX_REPORTS": "Parsisiųsti gautų laiškų aplanko ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pasirinkti gautų laiškų aplanką",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Komandos apžvalga",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_TEAM_REPORTS": "Parsisiųsti komandos ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pasirinkite komandą",
    "FILTERS": {
      "ADD_FILTER": "Pridėti Filtrą",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Ieškoti komandų"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Ataskaitas",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Parsisiųsti CSAT ataskaitas",
    "DOWNLOAD_FAILED": "Nepavyko parsisiųsti CSAT ataskaitų",
    "FILTERS": {
      "ADD_FILTER": "Pridėti Filtrą",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Ieškoti agentų",
        "INBOXES": "Search inboxes",
        "TEAMS": "Ieškoti komandų",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agentas"
      },
      "INBOXES": {
        "LABEL": "Gautų laiškų aplankas"
      },
      "TEAMS": {
        "LABEL": "Komanda"
      },
      "RATINGS": {
        "LABEL": "Reitingas"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontaktas",
        "AGENT_NAME": "Agentas",
        "RATING": "Reitingas",
        "FEEDBACK_TEXT": "Facebook komentaras",
        "CONVERSATION": "Pokalbis",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Iš viso atsakymų",
        "TOOLTIP": "Bendras surinktų atsakymų skaičius"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Pasitenkinimo balas",
        "TOOLTIP": "Bendras teigiamų atsakymų skaičius / Bendras atsakymų skaičius * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Atsakymo įvertinimas",
        "TOOLTIP": "Bendras atsakymų skaičius / Bendras skaičius išsiųstų CSAT apklausų pranešimų * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Išsaugoti",
      "CANCEL": "Atšaukti",
      "SAVING": "Išsaugoma...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Apžvalga",
    "LIVE": "Tiesiogiai",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Atidaryti pokalbius",
      "LOADING_MESSAGE": "Įkeliama pokalbio metrika...",
      "OPEN": "Atidaryti",
      "UNATTENDED": "Be priežiūros",
      "UNASSIGNED": "Ne priskirtas",
      "PENDING": "Laukiama"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Pokalbių srautas",
      "NO_CONVERSATIONS": "Pokalbių nėra",
      "CONVERSATION": "{count} pokalbis",
      "CONVERSATIONS": "{count} pokalbiai",
      "DOWNLOAD_REPORT": "Download report"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "Pokalbių nėra",
      "CONVERSATION": "{count} pokalbis",
      "CONVERSATIONS": "{count} pokalbiai",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Agentų pokalbiai",
      "LOADING_MESSAGE": "Įkeliama agento metrika...",
      "NO_AGENTS": "Agentų pokalbių nėra",
      "TABLE_HEADER": {
        "AGENT": "Agentas",
        "OPEN": "Atidaryti",
        "UNATTENDED": "Be priežiūros",
        "STATUS": "Būsena"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Komanda",
        "OPEN": "Atidaryti",
        "UNATTENDED": "Be priežiūros",
        "STATUS": "Būsena"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agento būsena",
      "ONLINE": "Prisijungęs",
      "BUSY": "Užimta",
      "OFFLINE": "Atsijungęs"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sekmadienis",
    "MONDAY": "Pirmadienis",
    "TUESDAY": "Antradienis",
    "WEDNESDAY": "Trečiadienis",
    "THURSDAY": "Ketvirtadienis",
    "FRIDAY": "Penktadienis",
    "SATURDAY": "Šeštadienis"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Pridėti Filtrą",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nieko nerasta",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agento Vardas",
        "INBOXES": "Gautų laiškų aplanko pavadinimas",
        "LABELS": "Etiketės pavadinimas",
        "TEAMS": "Komandos pavadinimas"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Gautų laiškų aplankas",
      "AGENTS": "Agentas",
      "LABELS": "Etiketė",
      "TEAMS": "Komanda"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Pokalbis",
        "AGENT": "Agentas"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Gautų laiškų aplankas",
    "AGENT": "Agentas",
    "TEAM": "Komanda",
    "LABEL": "Etiketė",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Sprendimų skaičius",
    "CONVERSATIONS": "Pokalbių kiekis"
  }
}
